$('.form-field--qty-input .btnqty').on('click', function(){
  var qty = parseInt($(this).parent('.form-field--qty-input').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 1) {
      qty--;
    }
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.form-field--qty-input').find('.quantity-input').val(qty);
}); 

function calculateCoverage() {
			const length = document.getElementById("length").value;
			const width = document.getElementById("width").value;
			const coats = document.getElementById("coats").value;
            const coverageMin = document.getElementById("coverageMin").value;
            const coverageMax = document.getElementById("coverageMax").value;

			const totalAreaMin = ((length * width * coats) / coverageMin).toFixed(1);
            const totalAreaMax = ((length * width * coats) / coverageMax).toFixed(1);


            document.getElementById("coverage-result").classList.add('result-opened');
			document.getElementById("resultMin").innerHTML = totalAreaMin;
            document.getElementById("resultMax").innerHTML = totalAreaMax;
};
